import { Service } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { TemporarySessionStateModel } from './temporary-session-state.model';
import {
  TemporarySessionStateClear,
  TemporarySessionStateSetIsFirstLogin,
  TemporarySessionStateSetMustChangePassword,
  TemporarySessionStateSetPasswordChangeToken,
  TemporarySessionStateSetUserIdAndEmail,
} from './temporary-session.actions';

const DEFAULT_STATE: TemporarySessionStateModel = {
  userId: undefined,
  email: undefined,
  isFirstLogin: false,
  mustChangePassword: false,
  passwordChangeToken: null,
};

@State<TemporarySessionStateModel>({
  name: 'state__temporary_session',
  defaults: DEFAULT_STATE,
})
@Service({ autoProvided: false })
export class TemporarySessionState {
  @Selector()
  public static userId(state: TemporarySessionStateModel): string | undefined {
    return state.userId;
  }

  @Selector()
  public static userEmail(state: TemporarySessionStateModel): string | undefined {
    return state.email;
  }

  @Selector()
  public static isFirstLogin(state: TemporarySessionStateModel): boolean {
    return state.isFirstLogin;
  }

  @Selector()
  public static mustChangePassword(state: TemporarySessionStateModel): boolean {
    return state.mustChangePassword;
  }

  @Selector()
  public static passwordChangeToken(state: TemporarySessionStateModel): string | null {
    return state.passwordChangeToken;
  }

  @Action(TemporarySessionStateSetUserIdAndEmail)
  public setUserIdAndEmail(ctx: StateContext<TemporarySessionStateModel>, action: TemporarySessionStateSetUserIdAndEmail) {
    ctx.patchState({ userId: action.userId, email: action.email });
  }

  @Action(TemporarySessionStateSetIsFirstLogin)
  public setIsFirstLogin(ctx: StateContext<TemporarySessionStateModel>, action: TemporarySessionStateSetIsFirstLogin) {
    ctx.patchState({ isFirstLogin: action.isFirstLogin });
  }

  @Action(TemporarySessionStateSetMustChangePassword)
  public setMustChangePassword(ctx: StateContext<TemporarySessionStateModel>, action: TemporarySessionStateSetMustChangePassword) {
    ctx.patchState({ mustChangePassword: action.mustChangePassword });
  }

  @Action(TemporarySessionStateSetPasswordChangeToken)
  public setPasswordChangeToken(ctx: StateContext<TemporarySessionStateModel>, action: TemporarySessionStateSetPasswordChangeToken) {
    ctx.patchState({ passwordChangeToken: action.passwordChangeToken });
  }

  @Action(TemporarySessionStateClear)
  public clear(ctx: StateContext<TemporarySessionStateModel>) {
    ctx.setState({ ...DEFAULT_STATE });
  }
}
